import { sysAxios } from '@/libs/APIrequest'

export const Login = formData => {
    return sysAxios.post('/api/login', formData)
}

export const GetUserInfo = () => {
    return sysAxios.get('/api/GetUserInfo')
}

export const UpdatePwd = form => {
    return sysAxios.post('/api/users/UpdatePwd', form)
}